/*
  kap_product-stack.js — "Title, rating and price above the image" for the stacked product layout.

  Below 992px .product.grid stacks into one column, and this moves the title, rating/tagline and
  price ABOVE the media wrapper. It relocates the real nodes rather than rendering a second copy,
  because the price block is addressed by id (#price-<section>) by Dawn's variant picker, the
  discount preview and the sticky bar — duplicating it would break all three.

  Original positions are recorded on first move so the desktop layout restores exactly.
*/
(function () {
  const BREAKPOINT = '(max-width: 991.98px)';

  function collect(root) {
    const info = root.querySelector('.product__info-container');
    if (!info) return [];
    // Document order matters: title, then rating/tagline, then price.
    return [
      info.querySelector('.product__title'),
      info.querySelector('.rating-tagline-wrap'),
      info.querySelector('[id^="price-"]'),
    ].filter(Boolean);
  }

  function init(root) {
    const target = root.querySelector('[data-product-stack-top]');
    if (!target || target.dataset.stackReady === 'true') return;
    target.dataset.stackReady = 'true';

    const nodes = collect(root);
    if (!nodes.length) return;

    // Remember where each node came from so it can go back untouched.
    const home = nodes.map((node) => ({ node: node, parent: node.parentNode, next: node.nextSibling }));

    const mql = window.matchMedia(BREAKPOINT);

    function apply() {
      if (mql.matches) {
        home.forEach((entry) => {
          if (entry.node.parentNode !== target) target.appendChild(entry.node);
        });
        target.hidden = false;
      } else {
        // Restore in REVERSE document order. Each node's recorded `next` sibling may itself be
        // one of the moved nodes (title's next is the rating wrap, whose next is the price) —
        // restoring front-to-back passed insertBefore a reference node still sitting in the
        // stack-top container, which throws NotFoundError and left the layout half-moved after
        // resizing mobile → desktop. Going back-to-front, every `next` is already home (or was
        // never moved) by the time it's used; the parentNode check is a backstop for nodes a
        // re-render removed.
        for (let i = home.length - 1; i >= 0; i--) {
          const entry = home[i];
          if (entry.node.parentNode !== target) continue;
          const ref = entry.next && entry.next.parentNode === entry.parent ? entry.next : null;
          entry.parent.insertBefore(entry.node, ref);
        }
        target.hidden = true;
      }
    }

    apply();
    // addEventListener on MediaQueryList is Safari 14+; fall back for older iOS.
    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', apply);
    else if (typeof mql.addListener === 'function') mql.addListener(apply);

    // Backstop: apply() is idempotent, so also run it on resize. Covers rotation and any
    // environment where the media-query change event doesn't arrive.
    let t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 100);
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.product.grid').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();

  // The section re-renders on variant change and in the theme editor.
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();

